import posthog from 'posthog-js';
import { PostHogProvider as PostHogSDKProvider } from 'posthog-js/react';
import React from 'react';
import { getEnv } from '../constants/environment';

const env = getEnv();

if (env === 'prod') {
    posthog.init('phc_ViYD0HiJjPKW0YoyU6Oj0gHMeSLNfKqFvwxxwVgCCeH', {
        api_host: 'https://us.i.posthog.com',
        disable_surveys: true,
    });
}

export const PostHogProvider = ({ children }: { children: React.ReactNode }) => {
    if (env === 'prod') {
        return <PostHogSDKProvider client={posthog}>{children}</PostHogSDKProvider>;
    }
    return <>{children}</>;
};
